import { render } from "./SbBookingDetails.vue?vue&type=template&id=c9dbc106"
import script from "./SbBookingDetails.vue?vue&type=script&lang=js"
export * from "./SbBookingDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__